import Highcharts from 'utils/highcharts';
import { filter, map } from 'lodash';
import moment from 'moment';
import { highchartsOptionsSetter } from 'utils/highchartsOptionsSetter';
import {
  DailySummaryDto,
  SubstanceUsageType,
} from '@peartherapeutics/hylia-api-client';
import { intensityChartConfig } from './chartConfig';

highchartsOptionsSetter(Highcharts);

interface IChartData {
  x: number;
  y: number;
  usedToday: string;
}

/** Sets the chart axis values for usage data AND overall chart */
export const transformToChartData = (data: DailySummaryDto[]): IChartData[] =>
  map(data, ({ date, averageCravingIntensity, substanceUse, triggers }) => ({
    x: new Date(date).valueOf(),
    y: averageCravingIntensity,
    usedToday: substanceUse,
    triggers,
  }));

export const draw = (props: {
  elementId: string;
  chartData: IChartData[];
  timezone: string;
  maxDate: string;
}) => {
  const { elementId, timezone, maxDate, chartData } = props;
  const config = intensityChartConfig(elementId, timezone, maxDate);

  // @ts-ignore
  const stockChart = new Highcharts.StockChart({
    ...config,
    series: [
      {
        name: 'Craving',
        className: 'color-craving',
        data: filter(chartData, { usedToday: SubstanceUsageType.NoUse }),
      },
      {
        name: 'Used',
        className: 'color-used',
        data: filter(chartData, { usedToday: SubstanceUsageType.Used }),
        marker: { symbol: 'circle' },
      },
    ] as any,
  });

  return stockChart;
};
